// Pricing configuration for India and International markets

export interface RegionalPricing {
    baseline: number;
    pro: number;
    ultimate: number;
    ultimateRecurring?: number; // Monthly price after first month (only for India)
}

export interface PricingConfig {
    currency: string;
    currencySymbol: string;
    pricing: RegionalPricing;
    hasBloodPanel: boolean;
    hasAddOns: boolean;
    locale: string;
}

export const INDIA_CONFIG: PricingConfig = {
    currency: 'INR',
    currencySymbol: '₹',
    pricing: {
        baseline: 2999,
        pro: 4599,
        ultimate: 3999,
        ultimateRecurring: 1999,
    },
    hasBloodPanel: true,
    hasAddOns: true,
    locale: 'en-IN',
};

export const INTERNATIONAL_CONFIG: PricingConfig = {
    currency: 'USD',
    currencySymbol: '$',
    pricing: {
        baseline: 59,
        pro: 99,
        ultimate: 129,
    },
    hasBloodPanel: false,
    hasAddOns: false,
    locale: 'en-US',
};

export function getPricingConfig(isInternational: boolean): PricingConfig {
    return isInternational ? INTERNATIONAL_CONFIG : INDIA_CONFIG;
}

export function formatPrice(price: number, config: PricingConfig): string {
    return `${config.currencySymbol}${price.toLocaleString(config.locale)}`;
}

export function getPlanPrice(planId: 'baseline' | 'performance' | 'complete', config: PricingConfig): number {
    switch (planId) {
        case 'baseline':
            return config.pricing.baseline;
        case 'performance':
            return config.pricing.pro;
        case 'complete':
            return config.pricing.ultimate;
    }
}
